<template>
    <div class="aging-config-time">
        <el-popover placement="top" width="260" trigger="click" popper-class="aging-config-time-pop"
            :value="visiable" @show="show" @hide="visiable = false">
            <div class="el-time-range-picker__content">
                <div class="el-time-range-picker__cell range-picker_day">
                    <div class="el-time-range-picker__header">输入天</div>
                    <div class="el-time-panel__content day">
                        <el-input
                            v-model="nowday"
                            @input="handleClick('day', nowday)"
                            onkeyup="this.value=this.value.replace(/\D/g,'')"
                            clearable>
                        </el-input>
                    </div>
                </div>
                <div class="el-time-range-picker__cell range-picker_time">
                    <div class="el-time-range-picker__header">选择时间</div>
                    <div>
                        <div class="el-time-range-picker__body el-time-panel__content">
                            <time-spinner class="aging-time-spinner"
                                :hours="hours" @change="changeTime"></time-spinner>
                        </div>
                    </div>
                </div>
            </div>
            <div class="el-time-panel__footer">
                <button
                type="button"
                class="el-time-panel__btn cancel"
                @click="handleCancel">取消</button>
                <button
                type="button"
                class="el-time-panel__btn confirm"
                @click="handleConfirm">确定</button>
            </div>
            <el-input slot="reference" v-model="time" readonly></el-input>
        </el-popover>
    </div>
</template>
<script>
import TimeSpinner from './TimeSpinner';
export default {
    components: { TimeSpinner },
    props: {
        agingDay: {
            type: Number,
            default: 0
        },
        agingHour: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            visiable: false,
            oldDayVal: this.agingDay,
            oldHoursVal: this.agingHour,
            nowday: ''
        };
    },
    computed: {
        day() {
            return this.agingDay;
        },
        hours() {
            return this.agingHour;
        },
        time() {
            return `${this.day || '0'}天 | ${this.hours || '00'}:00:00`;
        }
    },
    methods: {
        show() {
            this.oldDayVal = this.agingDay;
            this.oldHoursVal = this.agingHour;
            this.nowday = this.agingDay;
            this.visiable = true;
        },
        changeTime(data) {
            this.$emit('change', { type: data.type, value: data.value });
        },
        modifyDateField(type, value) {
            switch (type) {
            case 'day': this.$emit('change', { type, value }); break;
            }
        },
        handleClick(type, value) {
            if (value * 1 > 50) {
                this.nowday = '';
                return this.$message.warning('只能输入小于51的正整数！');
            }
            this.modifyDateField(type, value * 1);
        },
        handleCancel() {
            this.nowday = this.oldDayVal;
            this.visiable = false;
            this.$emit('change', { type: 'day', value: this.oldDayVal });
            this.$emit('change', { type: 'hours', value: this.oldHoursVal });
        },
        handleConfirm() {
            this.oldDayVal = this.day;
            this.oldHoursVal = this.hours;
            this.visiable = false;
        }
    }
};
</script>
<style lang="less">
.aging-time-spinner {
    .spinner-top {
        margin-top: 80px;
    }
}
.range-picker_day {
    width: 28%;
}
.range-picker_time {
    width: 72%;
}
.aging-config-time-pop {
    padding-bottom: 0;
}
.day{
    padding: 80px 0px;
    border:1px solid #e9e9e9;
}
</style>